module.exports = __webpack_public_path__ + "assets/lessons/en/lesson7/modals/lesson_7_6_c.pdf";